import { render, staticRenderFns } from "./workTaskDetailList.vue?vue&type=template&id=fa065254&scoped=true"
import script from "./workTaskDetailList.vue?vue&type=script&lang=js"
export * from "./workTaskDetailList.vue?vue&type=script&lang=js"
import style0 from "./workTaskDetailList.vue?vue&type=style&index=0&id=fa065254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa065254",
  null
  
)

export default component.exports